import { getApiClient } from '@src/services/api-client'
import { useMutation } from '@tanstack/react-query'

export interface ComputeYtdIncomeRequest {
  ytdGross: number
  hiringDate: string
  payPeriodEndDate: string
}

export interface ComputeYtdIncomeResponse {
  annualSalary: number
}

export interface ComputeFlinksIncomeRequest {
  netAmountPerPeriod: number
  payFrequency: string
  provinceIso: string
}

export interface ComputeFlinksIncomeResponse {
  grossAnnualIncome: number
}

const computeYtdIncome = async (request: ComputeYtdIncomeRequest): Promise<ComputeYtdIncomeResponse> => {
  const response = await getApiClient().post<ComputeYtdIncomeResponse>(
    '/Applications/IncomeCalculator/ComputeYtdIncome',
    request,
  )
  return response.data
}

const computeFlinksIncome = async (request: ComputeFlinksIncomeRequest): Promise<ComputeFlinksIncomeResponse> => {
  const response = await getApiClient().post<ComputeFlinksIncomeResponse>(
    '/Applications/IncomeCalculator/ComputeFlinksIncome',
    request,
  )
  return response.data
}

export const useComputeYtdIncome = () => {
  const { mutateAsync, isPending, data } = useMutation({ mutationFn: computeYtdIncome })
  return [mutateAsync, isPending, data] as const
}

export const useComputeFlinksIncome = () => {
  const { mutateAsync, isPending, data, isError, error } = useMutation({ mutationFn: computeFlinksIncome })
  return [mutateAsync, isPending, data, isError, error] as const
}
